
import { Component } from "vue-property-decorator";
import { EpgItem } from "@/services/apiService/api.types";
import { Getter, Mutation } from "vuex-class";
import {
  ChannelsPageGetter,
  ChannelsPageMutation,
  InfoChannelData
} from "@/components/channelsPage/types";
import { Namespace } from "@/store/types";
import DateTimeSection from "@/components/DateTimeSection.vue";
import { mixins } from "vue-class-component";
import { EpgHelpers } from "@/mixins/EpgHelpers";
import SpatialNavigation from "spatial-navigation-js";
import { keyCodeFinder } from "@/services/keyCodeService/keyCodeService";
import { KeySet } from "@/services/keyCodeService/keyCode.types";
import { digitCount } from "@/helpers/utils";
import { EventBus } from "@/main";
import { RouteName } from "@/router/types";
import { LocaleChannelsInfoPage } from "@/plugins/i18n/types";
import apiStorageInterface from "@/services/apiStorageInterface";

@Component({
  components: { DateTimeSection }
})
export default class InfoModal extends mixins(EpgHelpers) {
  @Mutation(ChannelsPageMutation.setShowInfoScreen, {
    namespace: Namespace.ChannelsPage
  })
  setShowInfoScreen!: (showInfoScreen: boolean) => void;

  @Getter(ChannelsPageGetter.getActiveChannelOverlayInfo, {
    namespace: Namespace.ChannelsPage
  })
  getActiveChannelOverlayInfo!: InfoChannelData | undefined;

  @Getter(ChannelsPageGetter.getActiveInfoScreenEpgItem, {
    namespace: Namespace.ChannelsPage
  })
  getActiveInfoScreenEpgItem!: EpgItem | undefined;

  @Getter(ChannelsPageGetter.getShowInfoScreen, {
    namespace: Namespace.ChannelsPage
  })
  getShowInfoScreen!: boolean;

  LocaleChannelsInfoPage = LocaleChannelsInfoPage;

  async mounted(): Promise<void> {
    SpatialNavigation.pause();
    SpatialNavigation.focus("#backBtn");
    this.channelList = await apiStorageInterface.fetchCustomChannelList();
  }

  get activeEpgItemSplash(): string {
    return this.getActiveInfoScreenEpgItem?.image
      ? this.getActiveInfoScreenEpgItem.image
      : this.imgPlaceholder;
  }

  get imgPlaceholder(): string {
    return require("/src/assets/images/square-image-placeholder.jpg");
  }

  get channelName(): string {
    return this.getActiveChannelOverlayInfo?.channelName
      ? this.getActiveChannelOverlayInfo.channelName
      : "";
  }

  get epgItemTitle(): string {
    return this.getActiveInfoScreenEpgItem?.title
      ? this.getActiveInfoScreenEpgItem.title
      : "";
  }

  get epgItemDescription(): string {
    return this.getActiveInfoScreenEpgItem?.description
      ? this.getActiveInfoScreenEpgItem.description
      : "";
  }

  get channelNum(): string {
    let channelNum = "";
    if (this.getActiveChannelOverlayInfo) {
      for (
        let i = 0;
        i < 3 - digitCount(this.getActiveChannelOverlayInfo.channelId);
        i++
      ) {
        channelNum += "0";
      }
      return channelNum + this.getActiveChannelOverlayInfo.channelId + ".";
    }

    return "000";
  }

  get showPlayBtn(): boolean {
    return !!(
      this.getActiveChannelOverlayInfo &&
      this.getActiveChannelOverlayInfo.channelCatchup
    );
  }

  get isChannelInUserPackage(): boolean {
    for (const channel of this.channelList) {
      if (channel.id === this.getActiveChannelOverlayInfo?.channelId)
        return true;
    }

    return false;
  }

  closeOverlay(): void {
    if (this.$route.name === RouteName.Buffet) {
      EventBus.$emit("infoOverlayClosed", this.getActiveInfoScreenEpgItem?.id);
      this.setShowInfoScreen(false);
      return;
    }

    //checking if channel card exists
    if (
      !document.getElementById(
        "channel" + this.getActiveChannelOverlayInfo?.channelId
      )
    ) {
      EventBus.$emit("cantRefocus");
    }

    EventBus.$emit(
      "infoOverlayClosed",
      this.getActiveChannelOverlayInfo?.channelId
    );
    this.setShowInfoScreen(false);
  }

  handleBackBtnAction(event: KeyboardEvent): void {
    SpatialNavigation.pause();
    switch (keyCodeFinder(event.keyCode)) {
      case KeySet.KEY_DOWN:
        SpatialNavigation.focus("#playBtn");
        break;
      case KeySet.KEY_ENTER:
      case KeySet.KEY_BACK:
      case KeySet.KEY_ESC:
        this.closeOverlay();
        break;
    }
  }

  handlePlayBtnAction(event: KeyboardEvent): void {
    SpatialNavigation.pause();
    switch (keyCodeFinder(event.keyCode)) {
      case KeySet.KEY_UP:
        SpatialNavigation.focus("#backBtn");
        break;
      case KeySet.KEY_ENTER:
        this.playChannel();
        break;
      case KeySet.KEY_BACK:
      case KeySet.KEY_ESC:
        this.closeOverlay();
        break;
    }
  }

  playChannel(): void {
    if (this.$route.name === RouteName.Buffet) {
      EventBus.$emit("playChannel", this.getActiveInfoScreenEpgItem?.id);
      return;
    }

    EventBus.$emit("playChannel", this.getActiveChannelOverlayInfo?.channelId);
  }
}
